// @ts-nocheck
import React from 'react';
import { FormattedMessage as T } from '@/components';

export default [
  {
    text: <T id={'general'} />,
    disabled: false,
    href: '/preferences/general',
  },
  {
    text: <T id={'users'} />,
    href: '/preferences/users',
  },
  {
    text: <T id={'preferences.estimates'} />,
    href: '/preferences/estimates',
  },
  {
    text: <T id={'preferences.invoices'} />,
    href: '/preferences/invoices',
  },
  {
    text: <T id={'preferences.receipts'} />,
    href: '/preferences/receipts',
  },
  {
    text: <T id={'preferences.creditNotes'} />,
    href: '/preferences/credit-notes',
  },
  {
    text: <T id={'currencies'} />,
    href: '/preferences/currencies',
  },
  {
    text: <T id={'branches.label'} />,
    href: '/preferences/branches',
  },
  {
    text: <T id={'warehouses.label'} />,
    href: '/preferences/warehouses',
  },
  {
    text: <T id={'accountant'} />,
    disabled: false,
    href: '/preferences/accountant',
  },
  {
    text: <T id={'items'} />,
    disabled: false,
    href: '/preferences/items',
  },
  {
    text: <T id={'sms_integration.label'} />,
    disabled: false,
    href: '/preferences/sms-message',
  },
  {
    text: <T id={'salespeople.label'} />,
    disabled: false,
    href: '/preferences/salespeople',
  },
  {
    text: <T id={'carriers'} />,
    disabled: false,
    href: '/preferences/carriers',
    userTypes: ['dropship'],
  },
  {
    text: <T id={'shipping_accounts'} />,
    disabled: false,
    href: '/preferences/shipping-accounts',
    userTypes: ['dropship'],
  },
  {
    text: <T id={'ship_methods'} />,
    disabled: false,
    href: '/preferences/ship-methods',
    userTypes: ['dropship'],
  },
  {
    text: <T id={'logo_library.label'} />,
    disabled: false,
    href: '/preferences/logo-library',
  }
];
